export default __webpack_public_path__ + "static/media/nossas_unidades_3.d31f2e2f.webp";